import React from 'react';
import { ChevronRight } from 'lucide-react';
import { WidgetCard } from '../ui/WidgetCard';
import { BookItem } from '../Elze/BookItem';
import { useNavigate } from 'react-router-dom';
import { books } from '../../data/books';
export function RecentWorksWidget() {
  const navigate = useNavigate();
  // Function to handle book click - standardized
  const handleBookClick = (bookId: string) => {
    navigate(`/book/${bookId}`);
  };
  // Take the first 5 books for display
  const recentBooks = books.slice(0, 5);
  return <WidgetCard title="Recent Works" actionArea={<a href="#" className="text-sm text-[#376770] flex items-center hover:underline" data-id="element-81">
          View all <ChevronRight size={16} data-id="element-82" />
        </a>} contentClassName="p-0" data-id="element-80">
      <div className="flex flex-col" data-id="element-83">
        {/* Filters */}
        <div className="border-b border-gray-100" data-id="element-84">
          <div className="flex items-center py-3.5 overflow-x-auto scrollbar-hide" data-id="element-85">
            <div className="flex space-x-2" data-id="element-86">
              <button className="px-3 sm:px-4 py-1.5 text-sm font-medium bg-[#C6D6AB] text-gray-800 rounded-md whitespace-nowrap" data-id="element-87">
                All
              </button>
              <button className="px-3 sm:px-4 py-1.5 text-sm font-medium text-gray-600 hover:bg-[#EFF2F1] rounded-md transition-colors whitespace-nowrap" data-id="element-88">
                Published
              </button>
              <button className="px-3 sm:px-4 py-1.5 text-sm font-medium text-gray-600 hover:bg-[#EFF2F1] rounded-md transition-colors whitespace-nowrap" data-id="element-89">
                In Progress
              </button>
            </div>
          </div>
        </div>
        {/* Book container with improved horizontal scroll */}
        <div className="py-5 relative" data-id="element-90">
          {/* Improved carousel container */}
          <div className="overflow-x-auto scrollbar-hide -mx-1 px-1" data-id="element-91">
            <div className="flex space-x-4 sm:space-x-5 w-max whitespace-nowrap" data-id="element-92">
              {recentBooks.map(book => <div key={book.id} className="w-[200px] flex-shrink-0 cursor-pointer" onClick={() => handleBookClick(book.id)} data-id="element-93">
                  <BookItem cover={book.cover} title={book.title} genre={book.genre} year={book.year} id={book.id} authorName={book.author.name} authorImage={book.author.image} onClick={() => handleBookClick(book.id)} titleClassName="text-xs" data-id="element-94" />
                </div>)}
            </div>
          </div>
          {/* Mobile scroll indicator */}
          <div className="text-xs text-gray-500 text-center mt-2 sm:hidden" data-id="element-95">
            ← Scroll horizontally →
          </div>
        </div>
      </div>
    </WidgetCard>;
}